<template>
    <div class="col-12 col-lg-7 text-center soc-login">
        <div class="pb-5">
            <div class="text-muted text-center mt-2 mb-3">{{ $t('login_with') }}</div>
            <div class="btn-wrapper text-center">
                <button v-if="flavorConfig.socialLogin.vk" @click="socialLogin('vkontakte')" class="btn btn-neutral btn-icon mb-2 mx-1">
                    <span class="btn-inner--icon"><img src="@/assets/icons/common/vk.svg"></span>
                    <span class="btn-inner--text">{{ $t('vk') }}</span>
                </button>
                <button v-if="flavorConfig.socialLogin.fb" @click="socialLogin('facebook')" class="btn btn-neutral btn-icon mb-2 mx-1">
                    <span class="btn-inner--icon"><img src="@/assets/icons/common/fb.svg"></span>
                    <span class="btn-inner--text">Facebook</span>
                </button>
                <button v-if="flavorConfig.socialLogin.google && !isAndroidApp() " @click="socialLogin('google')" class="btn btn-neutral btn-icon mb-2 mx-1">
                    <span class="btn-inner--icon"><img src="@/assets/icons/common/google.svg"></span>
                    <span class="btn-inner--text">Google</span>
                </button>
                <button v-if="flavorConfig.socialLogin.yandex" @click="socialLogin('yandex')" class="btn btn-neutral btn-icon mb-2 mx-1">
                    <span class="btn-inner--icon"><img src="@/assets/icons/common/yandex.svg"></span>
                    <span class="btn-inner--text">{{ $t('yandex') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .soc-login .btn {
        width: 150px;
    }
</style>

<script>
    import {isAndroid} from "../data/AndroidApi";

    export default {
        name: "SocialLogin",

        methods: {
            socialLogin(provider) {
                let redirectUri = ''
                let loginUri = process.env.VUE_APP_URL + process.env.VUE_APP_PUBLIC_PATH + 'user/login'
                if (this.$route.query.hasOwnProperty('return')) redirectUri = '&redirectUri=' + this.$route.query.return
                window.location.href = process.env.VUE_APP_API_URL + 'auth?authclient=' + provider + redirectUri + '&loginUri=' + loginUri
            },
            isAndroidApp() {
                return isAndroid()
            },
        }
    }
</script>

